import { useDisplayLabel } from '@ps/web-shared-components';
import type { ClassNameProp, Error } from '@ps/web-shared-components';
import classNames from 'clsx';
import type { FieldState } from 'final-form';
import React from 'react';

import { error } from './ValidationMessage.scss';

export type ValidationState = Pick<FieldState<object>, 'touched' | 'invalid'>;

type Props = Partial<Error> & Partial<ClassNameProp> & ValidationState;

const ValidationMessage: React.FC<Props> = ({ message, touched, invalid, className }) => {
  const displayMessage = useDisplayLabel(message);

  return displayMessage && touched && invalid ? (
    <div className={classNames(className, error)}>{displayMessage}</div>
  ) : null;
};

export default ValidationMessage;
